import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "../i18n";
import { cartTotal } from "../currency";

const L = {
    en: { waiting: "Your selection is waiting", items: (n) => (n === 1 ? "1 item" : `${n} items`), review: "Review Cart" },
    fr: { waiting: "Votre sélection vous attend", items: (n) => (n === 1 ? "1 article" : `${n} articles`), review: "Voir le Panier" },
    ar: { waiting: "مختاراتك بانتظارك", items: (n) => (n === 1 ? "قطعة واحدة" : `${n} قطع`), review: "مراجعة السلة" },
    bn: { waiting: "আপনার নির্বাচন অপেক্ষা করছে", items: (n) => (n === 1 ? "১টি পণ্য" : `${n}টি পণ্য`), review: "কার্ট দেখুন" },
};

export const CartBar = ({ items, open, onOpen }) => {
    const { lang } = useLang();
    const t = L[lang] ?? L.en;
    const [dismissed, setDismissed] = useState(false);
    const count = items.reduce((s, i) => s + i.qty, 0);

    useEffect(() => setDismissed(false), [count]);

    const show = count > 0 && !open && !dismissed;

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 sm:gap-6 bg-charcoal border border-gold/40 px-5 sm:px-7 py-3.5 shadow-2xl"
                    data-testid="cart-reminder-bar"
                >
                    <div className="flex flex-col">
                        <span className="text-[10px] tracking-[0.25em] uppercase text-gold">{t.waiting}</span>
                        <span className="text-xs text-ivory/70 mt-0.5" data-testid="cart-bar-summary">
                            {t.items(count)} · {cartTotal(items, lang)}
                        </span>
                    </div>
                    <button
                        data-testid="cart-bar-review-button"
                        onClick={onOpen}
                        className="bg-gold text-charcoal px-5 py-2.5 text-[10px] tracking-[0.25em] uppercase hover:bg-goldlight transition-colors duration-300"
                    >
                        {t.review}
                    </button>
                    <button
                        data-testid="cart-bar-dismiss"
                        onClick={() => setDismissed(true)}
                        className="text-ivory/40 hover:text-ivory transition-colors"
                        aria-label="Dismiss"
                    >
                        <X size={14} />
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
